import React from "react";
import { imageExtensions } from "modules/helpers";

const createImageDocRenderer = (onExpand) => {
  const ImageDocRenderer = ({ mainState: { currentDocument } }) =>
    currentDocument ? (
      <div className="image-preview">
        <img
          src={currentDocument.fileData ?? currentDocument.uri}
          alt={currentDocument.fileName}
          onClick={() =>
            onExpand?.(currentDocument.uri, currentDocument.fileName)
          }
        />
      </div>
    ) : null;

  ImageDocRenderer.fileTypes = imageExtensions;
  ImageDocRenderer.weight = 1;

  return ImageDocRenderer;
};

export default createImageDocRenderer;
